export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9685.e9821b1e.jpg";